import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { th } from 'date-fns/locale';
import { AuthService } from 'src/app/shared/services/auth.service';
import { User } from 'src/core/interfaces/user';

@Component({
  selector: 'vex-widget-assistant',
  templateUrl: './widget-assistant.component.html',
  styleUrls: ['./widget-assistant.component.scss'],
  standalone: true,
  imports: [MatIconModule,CommonModule]
})
export class WidgetAssistantComponent implements OnInit {

    currentUser: User
    Welcome:any;
    WelcomeBack:any;

    constructor(private autherService: AuthService) { }

    ngOnInit() {

      var lang = localStorage.getItem('lang');
    if(lang == "ar"){
this.Welcome = "مرحبا";
this.WelcomeBack = "مرحبا بعودتك"
    }
    else{
this.Welcome = "Welcome";
this.WelcomeBack = "Welcome Back"
        }

  

      this.currentUser = this.autherService.currentUserValue
    }
}
